import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftSendEmailProps } from './props';
import { SarlaftSendEmail } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftSendEmail = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftSendEmailProps) => {
    const onSubmit = (data: SarlaftSendEmail) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('sendEmail', data?.sendEmail || false);
    }, [data]);

    return {
        formik,
    };
};
